import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import GameSceneRace from './GameSceneRace';

class ControlPointSign {

	gameSceneRace: GameSceneRace;
	
	screenObject;
	
	startPosition: THREE.Vector3;
	
	color = 0x000000FF;
	
	material: any;//THREE.MeshPhongMaterial;
	materialHalo: any;
	
	constructor(gameSceneRace: GameSceneRace, color: number, index: number) {
		this.gameSceneRace = gameSceneRace; 
		
		this.color = color;
		
		this.loading();
		
		this.screenObject = new THREE.Object3D();
		
		this.startPosition = this.screenObject.position; 
		
		this.gameSceneRace.sceneRootObject.add(this.screenObject);
		
		// объект упрощённый, условный - просто цветная пирамидка
		//const geo = new THREE.TetrahedronGeometry(2, 0);
		let geo: any = new THREE.ConeGeometry( 1.5, 2.5, 3 ); 
	
const haloVertexShader = /*glsl*/`
varying vec3 vertexNormal;
void main() {
     vertexNormal = normal;
     gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);   
}
`;
const haloFragmentShader = /*glsl*/`
varying vec3 vertexNormal;
void main() {
float intensity = pow(0.9 - dot(vertexNormal, vec3(0, 0, 1.0)), 2.0);
gl_FragColor = vec4(0.8, 1.0, 0.6, 0.2) * intensity;
}
`;	
		
		this.material = new THREE.MeshBasicMaterial({ color: this.color });
		
		
		this.materialHalo = new THREE.ShaderMaterial({
          vertexShader:haloVertexShader,
          fragmentShader:haloFragmentShader,
          blending: THREE.AdditiveBlending,
          side: THREE.BackSide
     })
		
		
//		this.material.shininess = 100;
		let mesh = new THREE.Mesh(geo, this.material);
		this.screenObject.add(mesh);		

		let meshHalo = new THREE.Mesh(geo, this.materialHalo);
		meshHalo.scale.x = 1.2;
		meshHalo.scale.y = 1.2;
		meshHalo.scale.z = 1.2;
		this.screenObject.add(meshHalo);		
		
		// рисуем (index + 1) столбиков над пирамидкой - вроде римского номера
		geo = new THREE.BoxGeometry(0.2, 1, 0.2);
		for (let i = 0; i <= index; i++) {
			
			mesh = new THREE.Mesh(geo, this.material);
			mesh.position.x = (i - index / 2) * 0.3;
			mesh.position.y = 2;
			this.screenObject.add(mesh);		
			
			meshHalo = new THREE.Mesh(geo, this.materialHalo);
			meshHalo.position.x = (i - index / 2) * 0.3;
			meshHalo.position.y = 2;
			meshHalo.scale.x = 1.2;
			meshHalo.scale.y = 1.2;
			meshHalo.scale.z = 1.2;
			this.screenObject.add(meshHalo);		
			
		}
		
		
		
	}
	/////////////////////////////////////////////////////////
	repaintTo(color: number) {
		// перекрашиваем 
		this.material.color.setHex(color);
	}
	/////////////////////////////////////////////////////////
	setStartPosition(x: number, y: number, z: number) {
		this.startPosition = new THREE.Vector3(x, y, z);
		this.screenObject.position.x = x;
		this.screenObject.position.y = y;
		this.screenObject.position.z = z;
	}
	/////////////////////////////////////////////////////////
	loading() {
		/*
		const loader = new GLTFLoader();
		loader.load('models/race_drag_start_and_finish_line.glb', (gltf) => {
			
			this.screenObject.add(gltf.scene);
		},
		(xhr) => {
			console.log('controlPoint loading: ' + (xhr.loaded / xhr.total) * 100 + '% loaded');
		},
		(error) => {
			console.log('controlPoint loading error! ' + error);
		});
		*/
	}
	/////////////////////////////////////////////////////////
	
}
export default ControlPointSign;